
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getPreviewImage } from '@/Util'
import { INewNote } from '../interface/INote'
@Component
export default class NewNote extends Vue {
  hasCustomCover = false
  customImage: string = ''
  customImageName: string = ''
  customImageBase = ''

  title = ''
  cover: 1 | 2 | 3 | 4 | 5 | 6 = 1

  coverIndexMap = new Map([
    [1, 'first'],
    [2, 'second'],
    [3, 'third'],
    [4, 'forth'],
    [5, 'fifth']
  ])

  customOnClick () {
    let ref: any = this.$refs['cover-upload']
    ref.click()
  }

  async addCustomCover (evt: any) {
    let file = evt.target.files[0]
    this.hasCustomCover = true
    if (file && file.type.startsWith('image/')) {
      console.log(file)
      this.customImage = file.name.replace(/\..+$/, '')
      this.customImageName = 'custom-' + file.name.replace(/\..+$/, '')
      this.customImageBase = await getPreviewImage(file)
      this.cover = 6
    }
  }

  onConfirm () {
    if (this.title === '') {
      alert('You didn\'t create an title')
      return false
    }
    let noteObj: INewNote = {
      title: this.title,
      isCustom: this.cover === 6,
      cover: this.cover === 6 ? this.customImageName : this.coverIndexMap.get(this.cover) || 'first',
      coverImage: this.cover === 6 ? this.customImageBase : ''
    }
    this.$emit('confirm', noteObj)
  }

  onClose () {
    this.$emit('close')
  }
}
